import qs from 'qs';
import { modulesMetaData } from './modules';

export const getDetailPageUrl = (module, routeParam, params) => {
	return getPageUrl({
		module,
		route: modulesMetaData[module].detail,
		routeParam,
		params,
	});
};

export const getListPageUrl = (module, params) => {
	return getPageUrl({
		module,
		route: modulesMetaData[module].list,
		routeParam: null,
		params,
	});
};

export const getEncodedUrlParams = (params) => {
	return qs.stringify(params, {
		arrayFormat: 'comma',
		allowDots: true,
		encode: true,
	});
};

export const getPageUrl = ({ module, route, routeParam, params }) => {
	if (!module) throw new Error('Module is not specified!');

	// In case we have contract/1 instead of contract/commondetails/1
	const pageRoute = route ? `/${route}` : '';

	const pageRouteParam = routeParam ? `/${routeParam}` : '';

	let pageUrl = `/${module}${pageRoute}${pageRouteParam}`;

	if (params) {
		const encodedValue = getEncodedUrlParams(params);
		pageUrl = pageUrl.concat(`?${encodedValue}`);
	}

	return pageUrl;
};
